import React from "react";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { numberWithCommas } from "utils";

const DetailReportModal = ({
  modalToggle,
  handleClose,
  choosenDetailReport,
  detailTotalPaymentSummary,
  detailTotalRealPaymentSummary,
  detailTotalTotalCostSummary,
  detailTotalNettoSummary,
  detailTotalRealNettoSummary,
}) => {
  return (
    <Modal
      autoFocus={false}
      size="lg"
      isOpen={modalToggle}
      toggle={handleClose}>
      <ModalHeader toggle={handleClose} />
      <ModalBody>
        <h3 className="text-center">Detail Report</h3>
        <Table bordered striped responsive>
          <thead className="text-primary">
            <tr>
              <th width="5%">No</th>
              <th>Vehicle</th>
              <th width="20%">Total Payment</th>
              <th width="20%">Total Cost</th>
              <th width="20%">Net</th>
            </tr>
          </thead>
          <tbody>
            {choosenDetailReport ? (
              choosenDetailReport.map((report, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    {report.code} - {report.licence_plate}
                  </td>
                  <td>
                    {numberWithCommas(report.total_payment_rent)}
                    <br />
                    <small>
                      {numberWithCommas(report.total_real_payment_rent)}
                    </small>
                  </td>
                  <td>{numberWithCommas(report.total_cost)}</td>
                  <td>
                    {numberWithCommas(report.netto)}
                    <br />
                    <small>{numberWithCommas(report.real_netto)}</small>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} align="center">
                  Data Kosong
                </td>
              </tr>
            )}
            <tr className="font-weight-bold">
              <td colSpan={2} className="text-center">
                TOTAL
              </td>
              <td>
                Rp. {numberWithCommas(detailTotalPaymentSummary)}
                <br />
                <small>
                  Rp. {numberWithCommas(detailTotalRealPaymentSummary)}
                </small>
              </td>
              <td>Rp. {numberWithCommas(detailTotalTotalCostSummary)}</td>
              <td>
                Rp. {numberWithCommas(detailTotalNettoSummary)} <br />
                <small>
                  Rp. {numberWithCommas(detailTotalRealNettoSummary)}
                </small>
              </td>
            </tr>
          </tbody>
        </Table>
      </ModalBody>
    </Modal>
  );
};

export default DetailReportModal;
